var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.judgedCompetitionsGrouped.length)?_vm._l((_vm.judgedCompetitionsGrouped),function(lvl){return _c('div',{key:lvl.competitionLevel.name},[_vm._v("\n      "+_vm._s(lvl.competitionLevel.name)+" ("+_vm._s(lvl.difficulties)+")\n    ")])}):[_vm._v("\n    "+_vm._s(_vm.$t(
        "people:personPage.rolesInShowsTab.competitions.noAssignement.text",
        "no assignment to specific class"
      ))+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }